import { HttpApiService } from "@/shared/services/httpApi.service";
import { readApiCode, readApiMessages, readApiStatus } from "@/shared/utils/apiError";

import type { BrebQrResolution, BrebQrResolutionError } from "../types/brebQr.types";

export const BREB_QR_ENDPOINTS = {
  RESOLVE: "/internal/payments/breb-qr/resolve",
} as const;

const BREB_QR_PAYMENTS_NOT_ENABLED_CODE = "breb_qr_payments_not_enabled";
/** A Bold payee while the organization does not have Bold QRs on. */
const BREB_QR_PAYEE_NOT_SUPPORTED_CODE = "breb_qr_payee_not_supported";

export class BrebQrService {
  /** Sent as scanned: trimming or re-encoding the string changes the EMVCo payload and breaks the read. */
  static async resolve(qrString: string): Promise<BrebQrResolution> {
    const { data } = await HttpApiService.post<BrebQrResolution, { qr_string: string }>(
      BREB_QR_ENDPOINTS.RESOLVE,
      { qr_string: qrString },
    );
    return data;
  }
}

export interface ClassifiedResolutionError {
  kind: BrebQrResolutionError;
  /** The backend's own sentence (already localised) for the definitive cases. */
  message: string | null;
}

export function classifyResolutionError(error: unknown): ClassifiedResolutionError {
  const status = readApiStatus(error);
  const message = readApiMessages(error).join(" ") || null;
  if (status === 404) return { kind: "key_not_found", message };
  if (status === 400) return { kind: "invalid", message };
  if (status === 422 && readApiCode(error) === BREB_QR_PAYEE_NOT_SUPPORTED_CODE) {
    return { kind: "unsupported", message: null };
  }
  if (status === 403 && readApiCode(error) === BREB_QR_PAYMENTS_NOT_ENABLED_CODE) {
    return { kind: "not_enabled", message: null };
  }
  if (status === 401 || status === 403) return { kind: "access_denied", message: null };
  return { kind: "unavailable", message: null };
}
